import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import { changeFilter } from '../../../../Actions/Dashboard/task';

import Button from '../../../Button';

class TaskInput extends React.Component {
  onClick(str) {
    this.props.dispatch(changeFilter(str));
  }

  render() {
    const active = { active: true };
    return (
      <ul>
        <li><Button {...this.props.filter === 'All' ? active : null} onClick={() => { this.onClick('All'); }} label="All" /></li>
        <li><Button {...this.props.filter === 'Active' ? active : null} onClick={() => { this.onClick('Active'); }} label="Active" /></li>
        <li><Button {...this.props.filter === 'Completed' ? active : null} onClick={() => { this.onClick('Completed'); }} label="Completed" /></li>
        {/* <li><Button onClick={() => this.props.dispatch(clearCompleted())} label="Clear Completed" className="clearCompleted" /></li> */}
      </ul>
    );
  }
}

TaskInput.propTypes = {
  dispatch: PropTypes.func.isRequired,
  filter: PropTypes.string.isRequired,
};

export default connect(state => ({ filter: state.taskfilter }), dispatch => ({ dispatch }))(TaskInput);



// WEBPACK FOOTER //
// ./src/Components/Dashboard/Pages/Task/Filters.jsx